import { createReducer, on } from '@ngrx/store';

import { FrequentFlyerResponse } from '@app/entities/frequent-flyer';
import { fetchFrequentFlyerProgramsSuccessAction } from '@app/store/actions/global.actions';

export const initialState: FrequentFlyerResponse[] = [];

export const frequentFlyerProgramReducer = createReducer(
  initialState,
  on(fetchFrequentFlyerProgramsSuccessAction, (state, { programs }) => programs)
);
